import { ref, withParams } from 'vuelidate/lib/validators/common';
import { helpers } from 'vuelidate/lib/validators';

export default lessThan => withParams(
  { type: 'lessThan', eq: lessThan, lessThan },
  (value, parentVm) => {
    if (!helpers.req(value) || (value && value <= lessThan)) {
      return true;
    }

    return false;
  },
);
